export type BaseFilterOption = {
  text: string
  value: string
}

export const FILTER_TYPE_BASE = Symbol('__BASE__')
export const FILTER_TYPE_RANGE = Symbol('__RANGE__')
export const FILTER_TYPE_ARRAY = Symbol('__ARRAY__')
export const FILTER_TYPE_ARRAY_WITH_IS_EMPTY = Symbol('__ARRAY_WITH_IS_EMPTY__')
export const FILTER_TYPE_RANGE_WITH_BOOL = Symbol('__RANGE_WITH_BOOL__')

export type FilterFieldType =
  | typeof FILTER_TYPE_BASE
  | typeof FILTER_TYPE_RANGE
  | typeof FILTER_TYPE_ARRAY
  | typeof FILTER_TYPE_ARRAY_WITH_IS_EMPTY
  | typeof FILTER_TYPE_RANGE_WITH_BOOL
